import { defineStore } from "pinia";
import { usePost } from "~/composables/useApi";

interface Rule {
	type: ">" | "<" | "=" | "<>" | "in" | "not in";
	value: string[] | number[];
}

interface CouponRules {
	[key: string]: Rule;
}

interface Coupon {
	"id": string,
    "code": string,
    "stock": number,
    "discount": number,
    "discount_type": string,
    "active": boolean,
    "expire_at": string | null,
    "rules": CouponRules,
    "discount_on": string
}


export const storeCoupon = defineStore('storeCoupon', {
	state: () => ({
		code: null,
		coupon: null as Coupon | null
	}),
	actions: {
		async calculate(product_id) {
			return usePost(`/product/${product_id}/calculate-voucher/${this.code}`)
				.then(data => data.changes);
		},
		validateCoupon(entity: any[]): boolean {
			if(!!this.coupon && !!this.coupon.rules) {
				for (const ruleKey in this.coupon.rules) {
					const rule = this.coupon.rules[ruleKey];
					const entityValue = entity[ruleKey.split('.')[1]];
					switch (rule.type) {
						case "in":
							if (!rule.value.includes(entityValue)) {
								return false;
							}
							break;
						case "not in":
							if (rule.value.includes(entityValue)) {
								return false;
							}
							break;
						case ">":
							if (entityValue <= rule.value[0]) {
								return false;
							}
							break;
						case "<":
							if (entityValue >= rule.value[0]) {
								return false;
							}
							break;
						case "=":
							if (entityValue !== rule.value[0]) {
								return false;
							}
							break;
						case "<>":
							if (entityValue === rule.value[0]) {
								return false;
							}
							break;
						default:
							return false;
					}
				}
				return true;
			}
			
			return false;
		},

	},
	getters: {
		getDescription: (state) => {
			const coupon: Coupon = state.coupon || {} as Coupon;
			if (!coupon?.discount || !state?.code) return null;
			const text = [
				"Desconto de ",
				coupon.discount_type === "percentage" ? coupon.discount : 'R$' + usePrice(coupon.discount),
				coupon.discount_type === "percentage" ? "%" : " reais",
				" na ",
				coupon.discount_on === "enroll" ? "taxa de adesão" : "parcela"
			];
			return text.join("");
		}
	},
	persist: true,
});
